import React from 'react'
import PostsDetails from './PostsDetails'

const DisplayPost = () => {
  return (
    <div className='home-container-2'>
        <PostsDetails />
    </div>
  )
}

export default DisplayPost